type Props = {
	video?: string;
	image?: string;
	title: string;
};

export const SponsoredHeroMedia = ({ video, image, title }: Props) => {
	if (video) {
		return <video src={video} muted loop autoPlay playsInline preload="auto" />;
	}

	if (image) {
		return <img src={image} alt={title} />;
	}

	return null;
};
